import ObjectClassManagementModal from '@/component/Tool/ObjectClassManagementModal';
import { VIconButton, useFlag } from '@/package';
import { Edit } from '@/package';

export const OpenObjectClassManagementButton = () => {
  const { value: visible, setFalse: hide, setTrue: show } = useFlag(false);

  return (
    <>
      <VIconButton variant="roundPrimary" Icon={Edit} onClick={() => show()} />

      <ObjectClassManagementModal
        visible={visible}
        onUpdateVisible={visible => (visible ? show() : hide())}
      />
    </>
  );
};

OpenObjectClassManagementButton.displayName = 'OpenObjectClassManagementButton';
